import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { authHeader } from '../../utils/headers'
import toast from 'react-hot-toast'
import config from '../../utils/config'

const url = config.testUrl

const initialState = {
	error: false,
	loading: false,
	success: false,
	message: '',
	inspections: [],
}

// post inspection form
export const create_inspection = createAsyncThunk(
	'inspection/post',
	async (obj, thunkAPI) => {
		try {
			const response = await axios.post(`${url}/reach/inspect`, obj)

			if (response.data) {
				toast.success('Form details has been sent succesfully!', {
					position: 'top-right',
				})
			}

			return response.data.data
		} catch (error) {
			const message =
				(error.response &&
					error.response.data &&
					error.response.data.message) ||
				error.message ||
				error.toString()
			return thunkAPI.rejectWithValue(message)
		}
	}
)

// get all inspections by admin
export const get_inspections = createAsyncThunk(
	'inspection/get',
	async (page, thunkAPI) => {
		try {
			const {
				authLogin: { admin },
			} = thunkAPI.getState()

			const response = await axios.get(
				`${url}/admin/inspections?pageNumber=${page}`,
				{
					headers: authHeader(admin.token),
				}
			)

			return response.data.data
		} catch (error) {
			const message =
				(error.response &&
					error.response.data &&
					error.response.data.message) ||
				error.message ||
				error.toString()
			return thunkAPI.rejectWithValue(message)
		}
	}
)

export const inspectionSlice = createSlice({
	name: 'inspection',
	initialState,
	reducers: {
		reset: (state) => {
			state.loading = false
			state.success = false
			state.error = false
			state.message = ''
			state.inspections = null
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(create_inspection.pending, (state) => {
				state.loading = true
			})
			.addCase(create_inspection.fulfilled, (state, action) => {
				state.loading = false
				state.success = true
			})
			.addCase(create_inspection.rejected, (state, action) => {
				state.loading = false
				state.error = true
				state.message = action.payload
			})
			.addCase(get_inspections.pending, (state) => {
				state.loading = true
			})
			.addCase(get_inspections.fulfilled, (state, action) => {
				state.loading = false
				state.inspections = action.payload
			})
			.addCase(get_inspections.rejected, (state, action) => {
				state.loading = false
				state.error = true
				state.message = action.payload
				state.inspections = null
			})
	},
})

export const { reset } = inspectionSlice.actions
export default inspectionSlice.reducer
